import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store';

interface PrivateRouteProps {
    children: ReactNode;
}

const PrivateRoute = ({ children }: PrivateRouteProps) => {
    const location = useLocation();
    const { isAuthenticated } = useSelector((state: RootState) => state.Auth);

    // Check if the user is authenticated
    if (!isAuthenticated) {
        // Redirect to the login page with the return URL
        return <Navigate to="/" state={{ from: location }} replace />;
    }

    // If authenticated, render the children components
    return <>{children}</>;
};

export default PrivateRoute; 